module.exports = __webpack_public_path__ + "static/img/lock.a841ebf0.png";